const  concat = "<br />"
const aboutIncredMLD = {
    "About InCred 1.5x Nifty Accelerator MLD Apr'26": [
        {
          question: "What is the issue date and the maturity date of the MLDs?",
          answer: "The MLD issue date is 1st Feb’24 and the maturity date is 3rd Apr’26."
        },
        {
          question: "What is the Underlying in this MLD?",
          answer: "The underlying in this MLD is the Nifty 50 Index with a participation ratio of 1.5x. This means that if the Nifty returns are 20%, the returns on the MLD would be 30%."
        },
        {
          question: "What are the Minimum and the Maximum coupons/returns?",
          answer: "The Minimum coupon/return would be 0% and the maximum coupon/return will be 33%."
        },
        {
          question: "Which dates will be considered for calculating the returns of Nifty?",
          answer: "The Nifty Returns will be calculated based on the Initial Fixing Level and the Final Fixing Level. The Initial Fixing Level would be the average of the closing Nifty 50 levels of 29th Feb’24 and 28th Mar’24. The Final Fixing level would be average of the levels of the Nifty 50 Index as on 29th Jan’26 & 26th Feb’26."
        },
        {
          question: "When will I receive the coupon/return on the MLDs?",
          answer: "The coupon/return will be realised at the Maturity of the MLD."
        },
        {
          question: "Is the MLD listed, secured and Credit Rated?",
          answer: "The MLD will be listed on BSE within 4 trading days of the Primary issue, is secured by loans receivable of IFSL and is rated CRISIL PP MLD A+ Stable."
        },
        {
            question: "What are the important details of the MLD offering?",
            answer:"Issuer Name: <b>InCred Financial Services Limited (IFSL)</b>" + concat +
            "Security Name: <b>InCred 1.5x Nifty Accelerator MLD April’26</b>" + concat +
            "ISIN: <b>INE321N07384</b>" + concat +
            "Nature of Instrument: <b>Secured Redeemable Principal Protected - Market Linked Non-Convertible Debenture (NCD)</b>" + concat +
            "Seniority: <b>Senior</b>" + concat +
            "Date of Issue: <b>1st February 2024</b>" + concat +
            "Credit Rating: <b>CRISIL PPMLD A+; Outlook - Stable</b>" + concat +
            "Face Value: <b>Rs. 1,00,000/Unit</b>" + concat +
            "Coupon/Returns: <b>Market Linked</b>" + concat +
            "Coupon/Returns Rate: <b>1.5x Nifty 50 Index Returns with maximum absolute returns of 33%</b>" + concat +
            "Coupon/Returns Frequency: <b>At Maturity</b>" + concat +
            "Principal Repayment: <b>At Maturity</b>" + concat +
            "Original Mode of Issue: <b>Private Placement</b>" + concat +
            "Listing Details: <b>Bombay Stock Exchange (BSE)</b>" + concat +
            "Maturity Date: <b>3rd April 2026</b>" + concat +
            "Tenor : <b>26 months</b>" + concat + 
            "Debenture Trustee: <b>Catalyst Trusteeship Limited</b>" + concat
          },

        // {
        //   question: "What will be the Annualized Returns on the MLD?",
        //   answer: "The Minimum Annualized returns would be 0% and the Max. Annualized returns would be xx%."
        // },
      ],
  }
  
  export default aboutIncredMLD;